import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../common/utils";

const fieldNameRE = /\.?([^.]+)$/;

export function NotifChanges({ json }) {
  const { t } = useTranslation();

  if (json === undefined) {
    return null;
  }

  const list = JSON.parse(json);
  if (!Array.isArray(list) || !list.length) {
    return null;
  }

  return (<div className="fs-75">{
    list.map(item => {
      let translation;
      const matches = item.match(fieldNameRE);
      try {
        translation = t(capitalizeFirstLetter(matches[1]));
      }
      catch {
        translation = undefined;
      }
      return translation === undefined ? item : translation;
    }).join(", ")
  }</div>);
}
